import { render, staticRenderFns } from "./QuitaUpdate.vue?vue&type=template&id=ed292912&scoped=true"
import script from "./QuitaUpdate.vue?vue&type=script&lang=js"
export * from "./QuitaUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed292912",
  null
  
)

export default component.exports